import React from "react";
import { useFragment } from "react-relay";

import { graphql } from "relay-runtime";

import { dispatchAnalyticsTrack } from "~/lib/segment";
import { Button } from "~/ui";
import Avatar from "~/ui/legacy/Avatar";
import { Modal } from "~/ui/legacyFellowIndex";

import bannerTop1 from "./banner-top-1.png";
import videoBgTop1 from "./video-bg-top-1.png";

import type { TopUserModal_viewer$key as ViewerKey } from "~/__generated__/TopUserModal_viewer.graphql";

import styles from "./TopUserModal.module.css";

const topUserFragment = graphql`
	fragment TopUserModal_viewer on Viewer {
		user {
			id
			fullName
			firstName
			image
			isTopUser
		}
	}
`;

interface Props {
	viewer: ViewerKey;
	onClose: () => void;
}

export default function TopUserModal({ onClose, ...props }: Props) {
	const { user } = useFragment<ViewerKey>(topUserFragment, props.viewer);

	const onReviewClick = React.useCallback(() => {
		dispatchAnalyticsTrack("Top User Modal Review G2");
	}, []);

	const onBackgroundClick = React.useCallback(() => {
		dispatchAnalyticsTrack("Top User Modal Download Zoom Background");
	}, []);

	return (
		<Modal onClose={onClose} className={styles.modal}>
			<Modal.Header onClose={onClose} className={styles.modalHeader}>
				<img className={styles.banner} src={bannerTop1} />
			</Modal.Header>
			<Modal.Body className={styles.modalBody}>
				<Avatar user={user} width="3rem" className={styles.avatar} />
				<div className={styles.title}>Congratulations!</div>
				<div className={styles.subtitle}>
					You&apos;ve earned a spot in the top 1% of Fellow users. You deserve a few perks!
				</div>
				<div className={styles.body}>
					As a top user,
					<ol type="1">
						<li>
							Claim exclusive rewards when you{" "}
							<a
								/* eslint-disable-next-line max-len */
								href="https://www.g2.com/contributor/fellow-v?secure%5Bpage_id%5D=fellow-v&secure%5Brewards%5D=true&secure%5Btoken%5D=d74de03a52cddd2cec4e88359df45536b003a9696d2498a16d5835d0ef61823a"
								target="_blank"
								rel="noopener"
								onClick={onReviewClick}
							>
								review Fellow on G2.
							</a>
						</li>
						<li>
							Download your custom Zoom/Meet background{" "}
							<a href={videoBgTop1} download onClick={onBackgroundClick}>
								here
							</a>
							.
						</li>
					</ol>
				</div>
			</Modal.Body>
			<Modal.Footer className={styles.modalFooter}>
				<Button variant="primary" size="normal" onClick={onClose}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
